import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./SideBar.css";
import { appNavs } from "../../config";
import SideBarNav from "./SidebarNav";
import SidebarNavToggle from "./SidebarNavToggle";

const SideBar = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  let location = useLocation();

  useEffect(() => {
    // Auto-collapse on mobile
    if (window.innerWidth <= 1024) {
      setIsExpanded(false);
    }
  }, []);

  // Dispatch event when sidebar state changes
  useEffect(() => {
    const event = new CustomEvent('sidebarStateChange', {
      detail: { collapsed: !isExpanded }
    });
    window.dispatchEvent(event);
  }, [isExpanded]);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const handleMouseEnter = () => {
    if (!isExpanded) {
      setIsHovered(true);
    }
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const isVisible = isExpanded || isHovered;

  return (
    <>
      <div className="btn-sidebar-nav">
        <SidebarNavToggle 
          expanded={isExpanded} 
          onChange={handleToggle}
          isVisible={isVisible}
        />
      </div>
      
      <div 
        className={`sidebar ${isVisible ? 'visible' : ''} ${isExpanded ? 'expanded' : 'collapsed'}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <div className="logo-icon">A</div>
            {isVisible && (
              <div className="logo-text">
                <h3>Admin Portal</h3>
                <span>Management System</span>
              </div>
            )}
          </div>
        </div>
        
        <SideBarNav 
          navs={appNavs} 
          isExpanded={isVisible}
          isCollapsed={!isExpanded}
        />
        
        {isVisible && (
          <div className="sidebar-footer">
            <div className="user-info">
              <div className="user-avatar">U</div>
              <div className="user-details">
                <span className="user-name">Admin User</span>
                <span className="user-role">Administrator</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SideBar;
